export const numberRegex = new RegExp("^[0-9]+$");